class ProductThumbnailController {
  constructor(gallery) {
    this.gallery = gallery;

    this.thumbWrapper = gallery.querySelector(
      ".m-product-media--slider__thumbnails .swiper-wrapper"
    );

    if (!this.thumbWrapper) return;

    this.thumbs = [...this.thumbWrapper.children];

    this.photoSwipe = gallery.lightbox;
    this.swiper = gallery.navSlider;

    this._variantChangeHandler = null;
    this._moreThumbClickBound = false;

    this.init();
  }

  init() {
    this.bindMoreThumbClick();
    this.watchVariantChanges();
    this.refresh();
  }

  /**
   * Handle click on the dynamic +N thumbnail.
   */
  bindMoreThumbClick() {
    if (this._moreThumbClickBound) return;

    this._moreThumbClickBound = true;

    this.thumbWrapper.addEventListener(
      "click",
      (e) => {
        const moreThumb = e.target.closest(".is-more-thumb");

        if (!moreThumb || !this.thumbWrapper.contains(moreThumb)) {
          return;
        }

        e.preventDefault();
        e.stopImmediatePropagation();

        const thumbIndex = this.thumbs.indexOf(moreThumb);

        if (thumbIndex === -1) {
          return;
        }

        console.log(
          "Opening +N thumbnail:",
          thumbIndex
        );

        if (this.photoSwipe) {
          this.photoSwipe.loadAndOpen(thumbIndex);
        }
      },
      true
    );
  }

  /**
   * Watch Shopify variant changes.
   */
  watchVariantChanges() {
    this._variantChangeHandler = () => {
      setTimeout(() => {
        this.refresh();
      }, 100);
    };

    document.addEventListener(
      "variant:change",
      this._variantChangeHandler
    );
  }

  /**
   * Reset all thumbnail states.
   */
  resetThumbs() {
    this.thumbs.forEach((thumb) => {
      thumb.style.display = "";

      thumb.classList.remove("is-more-thumb");

      const badge = thumb.querySelector(
        ".thumb-more-count"
      );

      if (badge) {
        badge.hidden = true;
        badge.textContent = "";
      }
    });
  }

  /**
   * Get currently selected variant.
   */
  getCurrentVariant() {
    /*
     * First try the product form associated
     * with this gallery.
     */
    const productForm =
      this.gallery.closest(
        'form[action="/cart/add"]'
      ) ||
      document.querySelector(
        'form[action="/cart/add"]'
      );

    const variantInput =
      productForm?.querySelector(
        '[name="id"]'
      ) ||
      document.querySelector(
        'form[action="/cart/add"] [name="id"]'
      );

    if (!variantInput) {
      console.warn(
        "ProductThumbnailController: variant input not found"
      );

      return null;
    }

    const variantId = Number(
      variantInput.value
    );

    if (!variantId) {
      console.warn(
        "ProductThumbnailController: invalid variant ID:",
        variantInput.value
      );

      return null;
    }

    return variantId;
  }

  /**
   * Get media IDs assigned to the current variant.
   */
  getVariantMediaIds() {
    const variantId =
      this.getCurrentVariant();

    if (!variantId) {
      return [];
    }

    const mapping =
      window.variantGroups ||
      this.gallery.variantGroups ||
      [];

    if (!Array.isArray(mapping)) {
      return [];
    }

    const variant = mapping.find(
      (item) =>
        Number(item.id) ===
        Number(variantId)
    );

    if (
      !variant ||
      !Array.isArray(variant.media)
    ) {
      return [];
    }

    return variant.media
      .map((media) => Number(media.id))
      .filter(Boolean);
  }

  /**
   * Add +N badge to the 5th thumbnail.
   *
   * First 4 thumbnails:
   *   normal
   *
   * 5th thumbnail:
   *   +N
   */
  setupMoreThumb(
    thumbs,
    totalCount
  ) {
    /*
     * [4] = 5th thumbnail
     */
    const fifthThumb = thumbs[4];
    // const fifthThumb = thumbs[3];

    /*
     * No 5th thumbnail.
     */
    if (!fifthThumb) {
      return;
    }

    /*
     * If there are only 4 or fewer images,
     * there is nothing to show as +N.
     */
    if (totalCount <= 4) {
    // if (totalCount <= 3) {
      return;
    }

    let badge =
      fifthThumb.querySelector(
        ".thumb-more-count"
      );

    /*
     * Create badge if it doesn't exist.
     */
    if (!badge) {
      badge =
        document.createElement("div");

      badge.className =
        "thumb-more-count";

      fifthThumb.appendChild(badge);
    }

    /*
     * First 4 images are shown normally.
     *
     * Therefore the 5th thumbnail represents:
     *
     * 5th + 6th + 7th + ...
     */
    const remaining = totalCount - 4;
    // const remaining = totalCount - 3;

    badge.hidden = false;

    badge.textContent = `+${remaining}`;

    /*
     * Mark this thumbnail so our delegated
     * click handler can recognize it.
     */
    fifthThumb.classList.add(
      "is-more-thumb"
    );
  }

  /**
   * Default gallery behavior when there is
   * no variant-specific media mapping.
   *
   * Result:
   *
   * [1] [2] [3] [4] [+N]
   */
  showDefaultThumbs() {
    /*
     * Reset everything.
     */
    this.resetThumbs();

    /*
     * Show first 5.
     * Hide everything after 5.
     */
    this.thumbs.forEach(
      (thumb, index) => {
        thumb.style.display =
          index < 5
          // index < 4
            ? ""
            : "none";
      }
    );

    /*
     * Put +N on 5th thumbnail.
     */
    this.setupMoreThumb(
      this.thumbs,
      this.thumbs.length
    );

    this.updateSwiper();
  }

  /**
   * Refresh thumbnails according to
   * selected variant.
   */
  refresh() {
    /*
     * Re-read thumbnails because Shopify/Swiper
     * can replace the DOM.
     */
    if (this.thumbWrapper) {
      this.thumbs = [
        ...this.thumbWrapper.children
      ];
    }

    const mediaIds =
      this.getVariantMediaIds();

    console.log(
      "Variant media IDs:",
      mediaIds
    );

    /*
     * No variant-specific mapping.
     *
     * Use default gallery.
     */
    if (!mediaIds.length) {
      this.showDefaultThumbs();
      return;
    }

    /*
     * Reset all thumbnails.
     */
    this.resetThumbs();

    /*
     * Find thumbnails belonging to
     * the current variant.
     */
    const matchingThumbs =
      this.thumbs.filter((thumb) => {
        const mediaId =
          Number(
            thumb.dataset.mediaId
          );

        return mediaIds.includes(
          mediaId
        );
      });

    console.log(
      "Matching thumbnails:",
      matchingThumbs
    );

    /*
     * Hide thumbnails that don't belong
     * to this variant.
     */
    this.thumbs.forEach(
      (thumb) => {
        if (
          !matchingThumbs.includes(
            thumb
          )
        ) {
          thumb.style.display =
            "none";
        }
      }
    );

    /*
     * Show only first 5 matching thumbnails.
     *
     * 1 → normal
     * 2 → normal
     * 3 → normal
     * 4 → normal
     * 5 → +N
     *
     * 6+ → hidden
     */
    matchingThumbs.forEach(
      (thumb, index) => {
        thumb.style.display =
          index < 5
          // index < 4
            ? ""
            : "none";
      }
    );

    /*
     * Add +N to 5th matching thumbnail.
     */
    this.setupMoreThumb(
      matchingThumbs,
      matchingThumbs.length
    );

    /*
     * Update Swiper.
     */
    this.updateSwiper();
  }

  /**
   * Update Swiper after changing
   * thumbnail visibility.
   */
  updateSwiper() {
    if (!this.swiper) {
      return;
    }

    requestAnimationFrame(() => {
      this.swiper.update();
    });
  }

  /**
   * Open gallery at a specific index.
   */
  openGallery(index = 3) {
    if (!this.photoSwipe) {
      return;
    }

    this.photoSwipe.loadAndOpen(
      index
    );
  }

  /**
   * Cleanup controller.
   */
  destroy() {
    if (
      this._variantChangeHandler
    ) {
      document.removeEventListener(
        "variant:change",
        this._variantChangeHandler
      );

      this._variantChangeHandler =
        null;
    }

    this._moreThumbClickBound =
      false;
  }
}


/* --------------------------------
   Auto Initialize
-------------------------------- */

window.ProductThumbnailController =
  ProductThumbnailController;


document.addEventListener(
  "DOMContentLoaded",
  () => {

    const initController = () => {

      document
        .querySelectorAll(
          "media-gallery"
        )
        .forEach((gallery) => {

          /*
           * Don't initialize twice.
           */
          if (
            gallery.__thumbControllerInitialized
          ) {
            return;
          }

          /*
           * Wait for Minimog gallery
           * initialization.
           */
          if (
            !gallery.lightbox ||
            !gallery.navSlider
          ) {
            setTimeout(
              initController,
              300
            );

            return;
          }

          /*
           * Initialize controller.
           */
          gallery.__thumbControllerInitialized =
            true;

          gallery.__thumbController =
            new ProductThumbnailController(
              gallery
            );
        });
    };

    initController();
  }
);


/* --------------------------------
   Shopify Theme Editor Support
-------------------------------- */

document.addEventListener(
  "shopify:section:load",
  () => {

    document
      .querySelectorAll(
        "media-gallery"
      )
      .forEach((gallery) => {

        /*
         * Destroy previous controller.
         */
        if (
          gallery.__thumbController
        ) {
          gallery.__thumbController.destroy();
        }

        gallery.__thumbControllerInitialized =
          false;

        gallery.__thumbController =
          null;
      });


    setTimeout(() => {

      document
        .querySelectorAll(
          "media-gallery"
        )
        .forEach((gallery) => {

          if (
            gallery.lightbox &&
            gallery.navSlider
          ) {

            gallery.__thumbControllerInitialized =
              true;

            gallery.__thumbController =
              new ProductThumbnailController(
                gallery
              );
          }
        });

    }, 300);
  }
);


// class ProductThumbnailController {
//   constructor(gallery) {
//     this.gallery = gallery;

//     this.thumbWrapper = gallery.querySelector(
//       ".m-product-media--slider__thumbnails .swiper-wrapper"
//     );

//     if (!this.thumbWrapper) return;

//     this.thumbs = [...this.thumbWrapper.children];

//     this.photoSwipe = gallery.lightbox;
//     this.swiper = gallery.navSlider;

//     this.init();
//   }

//   init() {
//     this.bindThumbs();
//     this.watchVariantChanges();
//     this.refresh();
//   }

//   bindThumbs() {
//     this.thumbs.forEach((thumb, index) => {
//       thumb.addEventListener(
//         "click",
//         (e) => {
//           if (index !== 3) return;

//           e.preventDefault();
//           e.stopImmediatePropagation();

//           if (this.photoSwipe) {
//             this.photoSwipe.loadAndOpen(3);
//           }

//           return false;
//         },
//         true
//       );
//     });
//   }

//   watchVariantChanges() {
//     document.addEventListener("variant:change", () => {
//       setTimeout(() => {
//         this.refresh();
//       }, 100);
//     });
//   }

//   showFirstFour() {
//     this.thumbs.forEach((thumb, index) => {
//       thumb.style.display = index < 4 ? "" : "none";
//     });

//     this.thumbs.forEach((thumb) => {
//       const badge = thumb.querySelector(".thumb-more-count");
//       if (badge) badge.hidden = true;
//     });

//     if (this.swiper) {
//       this.swiper.update();
//     }
//   }

//   updateBadge() {
//     const badge = this.thumbs[4]
//       ? this.thumbs[4].querySelector(".thumb-more-count")
//       : null;

//     if (!badge) return;

//     const hiddenCount = Math.max(this.thumbs.length - 4, 0);

//     if (hiddenCount > 1) {
//       badge.hidden = false;
//       badge.textContent = `+${hiddenCount}`;
//     } else {
//       badge.hidden = true;
//     }
//   }

//   getCurrentVariant() {
//     const variantInput = document.querySelector('[name="id"]');
//     if (!variantInput) return null;
//     return Number(variantInput.value);
//   }

//   getVisibleThumbs() {
//     return this.thumbs.filter((thumb) => thumb.style.display !== "none");
//   }

//   openGallery(index = 3) {
//     if (!this.photoSwipe) return;
//     this.photoSwipe.loadAndOpen(index);
//   }

//   getVariantMediaIds() {
//     const variantId = this.getCurrentVariant();
//     if (!variantId) return [];

//     const mapping =
//       window.variantGroups ||
//       this.gallery.variantGroups ||
//       [];

//     if (!Array.isArray(mapping)) return [];

//     let mediaIds = [];

//     mapping.forEach((item) => {
//       if (Number(item.id) === Number(variantId) && Array.isArray(item.media)) {
//         item.media.forEach((media) => {
//           mediaIds.push(Number(media.id));
//         });
//       }
//     });

//     return mediaIds;
//   }

//   refresh() {
//     const mediaIds = this.getVariantMediaIds();

//     // No variant-specific media mapped -> show default thumbnails.
//     if (!mediaIds.length) {
//       this.showFirstFour();
//       this.updateBadge();
//       return;
//     }

//     // Hide every thumb first, then reveal only the ones matching this variant.
//     this.thumbs.forEach((thumb) => {
//       thumb.style.display = "none";
//       const badge = thumb.querySelector(".thumb-more-count");
//       if (badge) badge.hidden = true;
//     });

//     const matchingThumbs = this.thumbs.filter((thumb) =>
//       mediaIds.includes(Number(thumb.dataset.mediaId))
//     );

//     matchingThumbs.forEach((thumb, i) => {
//       thumb.style.display = i < 4 ? "" : "none";
//     });

//     // Put the "+N more" badge on the 4th *matching* thumb, not a fixed DOM index.
//     const fourthThumb = matchingThumbs[3];

//     if (fourthThumb) {
//       const badge = fourthThumb.querySelector(".thumb-more-count");
//       const remaining = matchingThumbs.length - 3;

//       if (badge) {
//         if (remaining > 1) {
//           badge.hidden = false;
//           badge.textContent = "+" + remaining;
//         } else {
//           badge.hidden = true;
//         }
//       }
//     }

//     if (this.swiper) {
//       this.swiper.update();
//     }
//   }
// }

// /* -----------------------------
//    Auto Initialize
// ------------------------------ */

// window.ProductThumbnailController = ProductThumbnailController;

// document.addEventListener("DOMContentLoaded", () => {
//   const initController = () => {
//     document.querySelectorAll("media-gallery").forEach((gallery) => {
//       if (gallery.__thumbControllerInitialized) return;

//       // Wait until Minimog gallery has finished initializing
//       if (!gallery.lightbox || !gallery.navSlider) {
//         setTimeout(initController, 300);
//         return;
//       }

//       gallery.__thumbControllerInitialized = true;
//       gallery.__thumbController = new ProductThumbnailController(gallery);
//     });
//   };

//   initController();
// });

// /* -----------------------------
//    Shopify Theme Editor Support
// ------------------------------ */

// document.addEventListener("shopify:section:load", () => {
//   document.querySelectorAll("media-gallery").forEach((gallery) => {
//     gallery.__thumbControllerInitialized = false;
//   });

//   setTimeout(() => {
//     document.querySelectorAll("media-gallery").forEach((gallery) => {
//       if (gallery.lightbox && gallery.navSlider) {
//         gallery.__thumbControllerInitialized = true;
//         gallery.__thumbController = new ProductThumbnailController(gallery);
//       }
//     });
//   }, 300);
// });

// /* -----------------------------
//    Watch Variant Changes
// ------------------------------ */

// const variantObserver = new MutationObserver(() => {
//   document.querySelectorAll("media-gallery").forEach((gallery) => {
//     if (gallery.__thumbControllerInitialized && gallery.__thumbController) {
//       gallery.__thumbController.refresh();
//     }
//   });
// });

// const variantInput = document.querySelector('[name="id"]');

// if (variantInput) {
//   variantObserver.observe(variantInput, {
//     attributes: true,
//     attributeFilter: ["value"],
//   });

//   variantInput.addEventListener("change", () => {
//     document.querySelectorAll("media-gallery").forEach((gallery) => {
//       if (gallery.__thumbControllerInitialized && gallery.__thumbController) {
//         gallery.__thumbController.refresh();
//       }
//     });
//   });
// }